import { isExpiredDate } from 'shared/utils/time/is-expired-date.ts';
import { InvoiceStatus } from 'types/invoice-status.ts';

export const getStatusDescription = (status: string, endPaymentPeriodDate: string) => {
  const { diff, isExpired } = isExpiredDate(endPaymentPeriodDate);

  if (status === InvoiceStatus.Waiting && isExpired) {
    return `Payment delays of ${Math.abs(diff)} day(s). Pay the invoice immediately.`;
  }

  if (status === InvoiceStatus.Waiting) {
    return 'Waiting for payment.';
  }

  if (status === InvoiceStatus.Loss || status === InvoiceStatus.Problem) {
    return 'Payment problem. Pay the invoice immediately.';
  }

  if (status === InvoiceStatus.Completed) {
    return 'Paid.';
  }
};
